import { uniq } from 'lodash';
import { useSelector } from 'src/store';
import {
  selectAddOnItems,
  selectAvailableAddOnItems,
  selectAvailableCartItemCount,
  selectAvailableCartOrders,
  selectCart,
  selectCartGrandSubtotal,
  selectCartOrders,
  selectLineItemAvailabilitiesById,
  selectMultiCartDeliveryDate,
  selectMultiCartDeliveryDateTime,
  selectMultiCartIsEmpty,
  selectUnavailableLineItemIds,
} from 'src/store/cart/selectors';

export const useMultiCartSelector = (isEditingOrder: boolean) => {
  const state = useSelector((state) => {
    const cart = selectCart(state, isEditingOrder);
    const cartOrders = selectCartOrders(cart);
    const checkoutOrders = selectAvailableCartOrders(cart);
    const checkoutShefIds = checkoutOrders.map((order) => order.shef.id);
    const hasTrialShef = checkoutOrders.some((order) => order.shef?.shefProfile?.isTrialShef);

    return {
      numAvailableCartItems: selectAvailableCartItemCount(cart),
      subtotal: selectCartGrandSubtotal(cart),
      activeShefId: cart.activeCartShefId,
      shefIds: cart.shefs.ids as string[],
      unavailableLineItemIds: selectUnavailableLineItemIds(cart),
      lineItemAvailabilities: selectLineItemAvailabilitiesById(cart),
      addOnItems: selectAddOnItems(cart),
      availableAddOnItems: selectAvailableAddOnItems(cart),
      cartOrders,
      checkoutOrders,
      checkoutShefIds,
      hasTrialShef,
      deliveryDate: selectMultiCartDeliveryDate(cart),
      deliveryDateTime: selectMultiCartDeliveryDateTime(cart),
      isEmpty: selectMultiCartIsEmpty(cart),
      queuedActions: cart.queuedActions,
      queuedActionsShefIds: uniq(cart.queuedActions.map((action) => action.payload.foodItem.userId)),
    };
  });

  return state;
};
